"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupName = void 0;
var _react = require("react");
var _GroupName = require("./GroupName.styles");
var _hooks = require("../../../../../hooks");
var _AudiencePicker = require("../../../AudiencePicker.labels");
var _Modal = require("../../../../../Layout/Modal");
var _Button = require("../../../../../UI/Button");
var _Input = require("../../../../../UI/Input");
var _jsxRuntime = require("react/jsx-runtime");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var GroupName = function GroupName(props) {
  var _createGroupTempData;
  var onCancel = props.onCancel,
    onConfirm = props.onConfirm,
    createGroupTempData = props.createGroupTempData,
    setCreateGroupTempData = props.setCreateGroupTempData,
    _props$isEditMode = props.isEditMode,
    isEditMode = _props$isEditMode === void 0 ? false : _props$isEditMode;
  var styles = (0, _GroupName.useStyles)(props);
  var getLabel = (0, _hooks.useLabels)({
    labels: _AudiencePicker.labels
  });
  var _useSessionData = (0, _hooks.useSessionData)(),
    gender = _useSessionData.gender;
  var inputRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  var handleChangeGroupName = function handleChangeGroupName(val) {
    if (isEditMode) {
      setCreateGroupTempData(_objectSpread(_objectSpread({}, createGroupTempData), {}, {
        newGroupName: val
      }));
    } else {
      setCreateGroupTempData(_objectSpread(_objectSpread({}, createGroupTempData), {}, {
        groupName: val
      }));
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Header, {
      title: getLabel(isEditMode ? "input_new_group_name_".concat(gender) : "input_group_name_".concat(gender))
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Content, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-AudiencePicker__group-name'],
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Input.Input, {
          id: "groupName",
          type: "text",
          value: createGroupTempData && createGroupTempData[isEditMode ? 'newGroupName' : 'groupName'],
          onChange: handleChangeGroupName,
          ariaLabel: getLabel('group_name'),
          placeholder: getLabel("input_placeholder_".concat(gender)),
          ref: inputRef
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.Modal.Footer, {
      justifyContent: "space-between",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer.Section, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          view: "link",
          id: "backButton",
          onClick: onCancel,
          children: getLabel('back')
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer.Section, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          id: "confirmButton",
          onClick: onConfirm,
          isDisabled: !createGroupTempData || ((_createGroupTempData = createGroupTempData[isEditMode ? 'newGroupName' : 'groupName']) === null || _createGroupTempData === void 0 ? void 0 : _createGroupTempData.length) === 0,
          children: getLabel('confirm')
        })
      })]
    })]
  });
};
exports.GroupName = GroupName;